import { Editor as TinyMCEEditor } from "tinymce";

export const pageBreak = async (editor: TinyMCEEditor) => {
  editor.insertContent(
    `<div class="page-break" style=" page-break-after: always; position: absolute; background-color: #f1f1f1; width: 100%; height: 10px; left: 0; user-select: none; pointer-events: none;"></div><br></br>`
  );
};
